<div class="card-container mat-elevation-z1">
  <div class="card-content">
    <app-patient-search-component id="patientRequiredSearch" #patientRequiredSearch (selected)="onPatientSelected($event)"></app-patient-search-component>
    <div *ngIf="patientSearched">
      <app-patient-view-component id="patientRequiredViewComponent" [patient]="patient" #patientRequiredViewComponent></app-patient-view-component>
    </div>
  </div>
  <div class="clearfix">
    <div class="pull-right margin-right-medium">
      <button class="card-inline" type="button" (click)="reservationWizardService.cancel()" mat-button>CANCELAR</button>
    </div>
    <div class="card-footer">
      <button mat-button color="primary" matStepperPrevious>ANTERIOR</button>
      <button color="primary" mat-flat-button matStepperNext type="submit">SIGUIENTE</button>
    </div>
  </div>

</div>
